import React, { useRef, useEffect } from 'react';

type AutoResizeTextareaProps = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    name?: string;
    id?: string;
};

const AutoResizeTextarea: React.FC<AutoResizeTextareaProps> = ({
    value,
    onChange,
    placeholder = '',
    className = '',
    disabled = false,
    name = '',
    id = '',
}) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            const lineHeight = 12;
            if (textareaRef.current.scrollHeight > lineHeight) {
                textareaRef.current.style.height = `${textareaRef.current.scrollHeight * 1.1}px`;
            } else {
                textareaRef.current.style.height = `${textareaRef.current.scrollHeight -12}px`;
            }
        }
    }, [value]);

    return (
        <textarea
            name={name}
            id={id}
            ref={textareaRef}
            disabled={disabled}
            className={`w-full text-sm px-2 border border-gray-300 rounded-md resize-none overflow-hidden leading-none ${className}`}
            style={{
                minHeight: '10px',
                lineHeight: '18px',
                paddingTop: '8px',
                paddingBottom: '8px',
            }}
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
        />


    );
};

export default AutoResizeTextarea;
